import { Outlet } from 'react-router-dom';
import { SiteHeader, SiteFooter } from '@/components/layout/v3';

interface PublicLayoutProps {
  children?: React.ReactNode;
}

/**
 * Public layout wrapper for unauthenticated /demo/* pages.
 * Uses the V3 SiteHeader (public variant) and SiteFooter so demo
 * pages match the landing page chrome instead of the legacy mint
 * Header.
 *
 * SiteHeader is `position: fixed` (h-14) — pt-14 on main keeps
 * page content from rendering under it.
 */
export function PublicLayout({ children }: PublicLayoutProps) {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1 pt-14">{children || <Outlet />}</main>
      <SiteFooter />
    </div>
  );
}
